import React from "react";
import { useSelector } from "react-redux";

export default function TableOuterLabelMarkStatus({}) {
  const { markBatch } = useSelector((state) => state.assignmentsMark);
  const { total, pending, sent } = markBatch;
  return (
    <ul className="assignment-status">
      <li>
        Total <span>{total}</span>
      </li>
      <li>
        Pending <span>{pending}</span>
      </li>
      <li>
        Mark Sent <span>{sent}</span>
      </li>
    </ul>
  );
}
